import { Layout } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { StyledContainer, StyledPageInner } from "@components";
import { ILayout } from "@interfaces";
import { selectApp } from "@redux";
import { useFullScreen } from "src/Helpers/useFullscreen";

export const LayoutApp = (props: ILayout) => {
    //page hook
    const dispatch = useDispatch();
    //page state
    const { loading } = useSelector(selectApp);

    const fullHeight = useFullScreen();

    return (
        // <Spin
        //     style={{ display: "flex" }}
        //     spinning={loading}
        //     size="large"
        //     indicator={<IconLoading size={80} />}
        // >
        <StyledContainer style={{ height: fullHeight }}>
            <Layout className="workspace">
                <Layout.Content>
                    <StyledPageInner>{props.children}</StyledPageInner>
                </Layout.Content>
            </Layout>
        </StyledContainer>
        // </Spin>
    );
};
